import { LoadableAfterPaint } from '@confluence/loadable';

export const ScheduledStatus = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-banner-itemsscheduled-statusScheduledStatus" */ '../src/banner-items/scheduled-status/ScheduledStatus'
			)
		).ScheduledStatus,
});
